import NASAPhotos from "../../images/NASAPhotos.png";
import Banking from "../../images/Banking.png";
import Pizza from "../../images/pizza.png";
import RockPaper from "../../images/RockPaperScissors.png";
import Calculator from "../../images/Calculator.png";
import BlueW from "../../images/BlueW.png";

export const projectData = [
  {
    img: BlueW,
    alt: "project screenshot",
    title: "Human Rights First: Blue Witness",
    description: "Worked on an legacy project built by past developers and reported to a stakeholder with ideas and designs. Worked with a team of 7 web developers, including a lead designer, and 3 data scientists.",
    repoLink: "",
    deployLink: "",
    blogLink: "https://robert-petersen.medium.com/my-first-experience-with-a-legacy-project-496c6146810",
  },
  {
    img: NASAPhotos,
    alt: "project screenshot",
    title: "NASA Photos",
    description: "Website that searches and displays photos from the NASA Astronomy Photo of the Day API. Built using React, SASS, React-scroll and React-icons.",
    repoLink: "https://github.com/robert-petersen/shopify-nasa-challenge",
    deployLink: "https://shopify-nasa-challenge-zeta.vercel.app/",
    blogLink: "",
  },
  {
    img: Calculator,
    alt: "project screenshot",
    title: "Calculator App",
    description: "This is my solution to the Calculator app challenge on Frontend Mentor. Frontend Mentor challenges help you improve your coding skills by building realistic projects. Created using React, Redux, SASS, and CSS Grids.",
    repoLink: "https://github.com/robert-petersen/calculator-app",
    deployLink: "https://roberts-calculator-app.vercel.app/",
    blogLink: "",
  },
  {
    img: RockPaper,
    alt: "project screenshot",
    title: "Rock Paper Scissors",
    description: "An application to play rock paper scissors. Created using React, Styled Components, and React Icons.",
    repoLink: "https://github.com/robert-petersen/rock-paper-scissors",
    deployLink: "https://rock-paper-scissors-wine.vercel.app/",
    blogLink: "",
  },
  {
    img: Banking,
    alt: "project screenshot",
    title: "Banking Website",
    description: "Created a basic banking website using React, Styled Components, React Scroll, and React Icons. Application deployed using Vercel.",
    repoLink: "https://github.com/robert-petersen/smooth-scroll-styled-components",
    deployLink: "https://smooth-scroll-styled-components.vercel.app/",
    blogLink: "",
  },
  {
    img: Pizza,
    alt: "project screenshot",
    title: "Pizza Website",
    description: "Created a basic pizza website using React, Redux for state management, Styled Components, React Scroll, and React Icons. Application deployed using Vercel.",
    repoLink: "https://github.com/robert-petersen/pizza-website",
    deployLink: "https://pizza-website-one.vercel.app/",
    blogLink: "",
  },
  {
    img: "https://bdc2020.o0bc.com/wp-content/uploads/2018/04/CNR-Guys-Lede-scaled.jpg",
    alt: "project screenshot",
    title: "Food Truck Backend",
    description: "Created a database for a food truck application using Node.js, Express, Knex, SQLite3, bcryptjs, JWT, and deployment on Heroku.",
    repoLink: "https://github.com/robert-petersen/food-truck-database",
    deployLink: "",
    blogLink: "",
  },
  {
    img: "https://page-builder.ted.com/system/baubles/files/000/005/178/original/schoolcloud.png",
    alt: "project screenshot",
    title: "School in the Cloud Backend",
    description: "Created a database for a school task management application using Node.js, Express, Knex, SQLite3, bcryptjs, JWT, and deployment on Heroku. Lead a team of 5 developers for this project.",
    repoLink: "https://github.com/School-In-The-Cloud-LambdaSchool/SchoolDB",
    deployLink: "",
    blogLink: "",
  },
]

// For new project copy/paste

// {
//   img: "",
//   alt: "project screenshot",
//   title: "",
//   description: "",
//   repoLink: "",
//   deployLink: "",
//   blogLink: "",
// },